export type CustomRangeFilters = Record<string, { filter: string; count: number; value: string }>;

export const SortValues: Record<string, string> = {
  popularity: 'SalesVelocity365D desc',
  asc: 'product_effectiveprice_cents asc',
  desc: 'product_effectiveprice_cents desc',
  rating: 'product_rating desc',
};

export const effectiveRangeMap = {
  EffectivePriceRange: 'price',
  VelocityRange: 'Velocity',
  ProjectileWeightRange: 'ProjectileWeight',
  RatingRange: 'product_rating',
  AmmoWeightRange: 'AmmoWeight',
};
export const velocitiQueryParam = {
  // new values
  '': '',
  '00000000.0T00000250.0': '1',
  '00000250.0T00000500.0': '2',
  '00000500.0T00000750.0': '3',
  '00000750.0T00001000.0': '4',
  '00001000.0T*': '5',
  '00001000.0T\\*': '5',
};

export const velocitiesFilterQuery = {
  // new values
  '': '{!tag=VelocityRange}VelocityRange:""',
  '1': '{!tag=VelocityRange}VelocityRange:"00000000.0T00000250.0"',
  '2': '{!tag=VelocityRange}VelocityRange:"00000250.0T00000500.0"',
  '3': '{!tag=VelocityRange}VelocityRange:"00000500.0T00000750.0"',
  '4': '{!tag=VelocityRange}VelocityRange:"00000750.0T00001000.0"',
  '5': '{!tag=VelocityRange}VelocityRange:"00001000.0T*"',
  // previous values from 1 to 5
  '6': '{!tag=Velocity}Velocity:[0 TO 00000250.0]',
  '7': '{!tag=Velocity}Velocity:[00000250.0 TO 00000500.0]',
  '8': '{!tag=Velocity}Velocity:[00000500.0 TO 00000750.0]',
  '9': '{!tag=Velocity}Velocity:[00000750.0 TO 00001000.0]',
  '10': '{!tag=Velocity}Velocity:[00001000.0 TO 2.5]',
};

export const ratingQueryParam = {
  //new values
  '': '',
  '00000005.0T*': '5',
  '00000004.0T*': '4',
  '00000003.0T*': '3',
  '00000002.0T*': '2',
  '00000001.0T*': '1',
  '00000001.0T\\*': '1',
  '00000002.0T\\*': '2',
  '00000003.0T\\*': '3',
  '00000004.0T\\*': '4',
  '00000005.0T\\*': '5',
};

export const ratingFilterQuery = {
  // new values
  '': '{!tag=RatingRange}RatingRange:""',
  '5': '{!tag=RatingRange}RatingRange:"00000005.0T*"',
  '4': '{!tag=RatingRange}RatingRange:"00000004.0T*"',
  '3': '{!tag=RatingRange}RatingRange:"00000003.0T*"',
  '2': '{!tag=RatingRange}RatingRange:"00000002.0T*"',
  '1': '{!tag=RatingRange}RatingRange:"00000001.0T*"',
  // previous values from 1 to 5
  '10': '{!tag=product_rating}product_rating:[5 TO *]',
  '9': '{!tag=product_rating}product_rating:[4 TO *]',
  '8': '{!tag=product_rating}product_rating:[3 TO *]',
  '7': '{!tag=product_rating}product_rating:[2 TO *]',
  '6': '{!tag=product_rating}product_rating:[1 TO *]',
};

export const weightQueryParam = {
  // new values
  '': '',
  '*.0T00000001.0': '1',
  '\\*.0T00000001.0': '1',
  '00000001.0T00000008.0': '2',
  '00000008.0T00000010.0': '3',
  '00000010.0T00000014.0': '4',
  '00000014.0T00000018.0': '5',
  '00000018.0T00000025.0': '6',
  '00000025.0T00000040.0': '7',
  '00000040.0T00000070.0': '8',
  '00000070.0T*': '9',
  '00000070.0T\\*': '9',
  '00000001.0T00000008.': '2',
  '00000008.0T00000010.': '3',
  '00000010.0T00000014.': '4',
  '00000014.0T00000018.': '5',
  '00000018.0T00000025.': '6',
  '00000025.0T00000040.': '7',
  '00000040.0T00000070.': '8',
};

export const weightCustomQueries = {
  // new values
  '': '{!tag=ProjectileWeightRange}ProjectileWeightRange:""',
  '1': '{!tag=ProjectileWeightRange}ProjectileWeightRange:"*.0T0000001.0"',
  '2': '{!tag=ProjectileWeightRange}ProjectileWeightRange:"00000001.0T00000008.0"',
  '3': '{!tag=ProjectileWeightRange}ProjectileWeightRange:"00000008.0T00000010.0"',
  '4': '{!tag=ProjectileWeightRange}ProjectileWeightRange:"00000010.0T00000014.0"',
  '5': '{!tag=ProjectileWeightRange}ProjectileWeightRange:"00000014.0T00000018.0"',
  '6': '{!tag=ProjectileWeightRange}ProjectileWeightRange:"00000018.0T00000025.0"',
  '7': '{!tag=ProjectileWeightRange}ProjectileWeightRange:"00000025.0T00000040.0"',
  '8': '{!tag=ProjectileWeightRange}ProjectileWeightRange:"00000040.0T00000070.0"',
  '9': '{!tag=ProjectileWeightRange}ProjectileWeightRange:"00000070.0T*"',
  // previous values from 1 to 9
  '10': '{!tag=ProjectileWeight}ProjectileWeight:[* TO "00000001"]',
  '11': '{!tag=ProjectileWeight}ProjectileWeight:["00000001" TO "00000008"]',
  '12': '{!tag=ProjectileWeight}ProjectileWeight:["00000008" TO "00000010"]',
  '13': '{!tag=ProjectileWeight}ProjectileWeight:["00000010" TO "00000014"]',
  '14': '{!tag=ProjectileWeight}ProjectileWeight:["00000014" TO "00000018"]',
  '15': '{!tag=ProjectileWeight}ProjectileWeight:["00000018" TO "00000025"]',
  '16': '{!tag=ProjectileWeight}ProjectileWeight:["00000025" TO "00000040"]',
  '17': '{!tag=ProjectileWeight}ProjectileWeight:["00000040" TO "00000070"]',
  '18': '{!tag=ProjectileWeight}ProjectileWeight:["00000070" TO *]',
};

export const ammoWeightQueryParams = {
  '': '',
  '00000000.0T00000008.0': '1',
  '00000008.0T00000010.0': '2',
  '00000010.0T00000014.0': '3',
  '00000014.0T00000018.0': '4',
  '00000018.0T00000025.0': '5',
  '00000025.0T00000040.0': '6',
  '00000040.0T00000070.0': '7',
  '00000070.0T00000090.0': '8',
  '00000090.0T00000130.0': '9',
  '00000130.0T00000200.0': '10',
  '00000200.0T00000300.0': '11',
  '00000300.0T00000400.0': '12',
  '0000000.0T00000008.': '1',
  '0000008.0T00000010.': '2',
  '0000010.0T00000014.': '3',
  '0000014.0T00000018.': '4',
  '0000018.0T00000025.': '5',
  '0000025.0T00000040.': '6',
  '0000040.0T00000070.': '7',
  '0000070.0T00000090.': '8',
  '0000090.0T00000130.': '9',
  '0000130.0T00000200.': '10',
  '0000200.0T00000300.': '11',
  '0000300.0T00000400.': '12',
  '00000400.0T*': '13',
  Varies: '14',
};

export const ammoWeightCustomQueries = {
  '': '{!tag=AmmoWeightRange}AmmoWeightRange:""',
  '1': '{!tag=AmmoWeightRange}AmmoWeightRange:00000000.0T00000008.0',
  '2': '{!tag=AmmoWeightRange}AmmoWeightRange:00000008.0T00000010.0',
  '3': '{!tag=AmmoWeightRange}AmmoWeightRange:00000010.0T00000014.0',
  '4': '{!tag=AmmoWeightRange}AmmoWeightRange:00000014.0T00000018.0',
  '5': '{!tag=AmmoWeightRange}AmmoWeightRange:00000018.0T00000025.0',
  '6': '{!tag=AmmoWeightRange}AmmoWeightRange:00000025.0T00000040.0',
  '7': '{!tag=AmmoWeightRange}AmmoWeightRange:00000040.0T00000070.0',
  '8': '{!tag=AmmoWeightRange}AmmoWeightRange:00000070.0T00000090.0',
  '9': '{!tag=AmmoWeightRange}AmmoWeightRange:00000090.0T00000130.0',
  '10': '{!tag=AmmoWeightRange}AmmoWeightRange:00000130.0T00000200.0',
  '11': '{!tag=AmmoWeightRange}AmmoWeightRange:00000200.0T00000300.0',
  '12': '{!tag=AmmoWeightRange}AmmoWeightRange:00000300.0T00000400.0',
  '13': '{!tag=AmmoWeightRange}AmmoWeightRange:00000400.0T*',
  '14': '{!tag=AmmoWeightRange}AmmoWeightRange:Varies',
};

export const priceQueryParam = {
  // new values
  '': '',
  '00000000.0T00000100.0': '1',
  '00000100.0T00000250.0': '2',
  '00000250.0T00000500.0': '3',
  '00000500.0T00001000.0': '4',
  '00001000.0T*': '5',
  '00001000.0T\\*': '5',
  // previous values from 1 to 5
  '0:10000': '6',
  '10000:25000': '7',
  '25000:50000': '8',
  '50000:100000': '9',
  '100000:*': '10',
};

export const priceCustomQueries = {
  // new values
  '': '{!tag=EffectivePriceRange}EffectivePriceRange:""',
  '1': '{!tag=EffectivePriceRange}EffectivePriceRange:"00000000.0T00000100.0"',
  '2': '{!tag=EffectivePriceRange}EffectivePriceRange:"00000100.0T00000250.0"',
  '3': '{!tag=EffectivePriceRange}EffectivePriceRange:"00000250.0T00000500.0"',
  '4': '{!tag=EffectivePriceRange}EffectivePriceRange:"00000500.0T00001000.0"',
  '5': '{!tag=EffectivePriceRange}EffectivePriceRange:"00001000.0T*"',
  // previous values from 1 to 5
  '6': '{!tag=AnyPriceMin}AnyPriceMin:[0 TO 00000100]',
  '7': '{!tag=AnyPriceMin}AnyPriceMin:[00000100 TO 00000250]',
  '8': '{!tag=AnyPriceMin}AnyPriceMin:[00000250 TO 00000500]',
  '9': '{!tag=AnyPriceMin}AnyPriceMin:[00000500 TO 00001000]',
  '10': '{!tag=AnyPriceMin}AnyPriceMin:[00001000 TO *]',
};

export const mappedCustomFilters = {
  VelocityRange: velocitiQueryParam,
  RatingRange: ratingQueryParam,
  ProjectileWeightRange: weightQueryParam,
  EffectivePriceRange: priceQueryParam,
  AmmoWeightRange: ammoWeightQueryParams,
};

export const mappedCustomQueries = {
  VelocityRange: velocitiesFilterQuery,
  RatingRange: ratingFilterQuery,
  ProjectileWeightRange: weightCustomQueries,
  EffectivePriceRange: priceCustomQueries,
  AmmoWeightRange: ammoWeightCustomQueries,
};

export const velocityCustomValues = {
  // new values
  '1': '00000000.0T00000250.0',
  '2': '00000250.0T00000500.0',
  '3': '00000500.0T00000750.0',
  '4': '00000750.0T00001000.0',
  '5': '00001000.0T*',
  // previous values from 1 to 5
  '6': '0-250',
  '7': '250-500',
  '8': '500-750',
  '9': '750-1000',
  '10': '1000 and up',
};
export const weightCustomValues = {
  // new values
  '1': '*.0T00000001.0',
  '2': '00000001.0T00000008.0',
  '3': '00000008.0T00000010.0',
  '4': '00000010.0T00000014.0',
  '5': '00000014.0T00000018.0',
  '6': '00000018.0T00000025.0',
  '7': '00000025.0T00000040.0',
  '8': '00000040.0T00000070.0',
  '9': '00000070.0T*',
  // previous values from 1 to 9
  '10': '1',
  '11': '< 8',
  '12': '8 to 10',
  '13': '10 to 14',
  '14': '14 to 18',
  '15': '18 to 25',
  '16': '25 to 40',
  '17': '40 to 70',
  '18': '> 70',
};
export const ammoWeightCustomValues = {
  '1': '00000000.0T00000008.0',
  '2': '00000008.0T00000010.0',
  '3': '00000010.0T00000014.0',
  '4': '00000014.0T00000018.0',
  '5': '00000018.0T00000025.0',
  '6': '00000025.0T00000040.0',
  '7': '00000040.0T00000070.0',
  '8': '00000070.0T00000090.0',
  '9': '00000090.0T00000130.0',
  '10': '00000130.0T00000200.0',
  '11': '00000200.0T00000300.0',
  '12': '00000300.0T00000400.0',
  '13': '00000400.0T*',
  '14': 'Varies',
};
export const productRatingValues = {
  // new values
  '1': '00000001.0T*',
  '2': '00000002.0T*',
  '3': '00000003.0T*',
  '4': '00000004.0T*',
  '5': '00000005.0T*',
  // previous values from 1 to 5
  '6': '1:*',
  '7': '2:*',
  '8': '3:*',
  '9': '4:*',
  '10': '5',
};
export const priceCustomValues = {
  // new values
  '1': '00000000.0T00000100.0',
  '2': '00000100.0T00000250.0',
  '3': '00000250.0T00000500.0',
  '4': '00000500.0T00001000.0',
  '5': '00001000.0T*',
  // previous values from 1 to 5
  '6': '0:10000',
  '7': '10000:25000',
  '8': '25000:50000',
  '9': '50000:100000',
  '10': '100000:*',
};
export const mappedSelectedValues = {
  VelocityRange: velocityCustomValues,
  RatingRange: productRatingValues,
  ProjectileWeightRange: weightCustomValues,
  EffectivePriceRange: priceCustomValues,
  AmmoWeightRange: ammoWeightCustomValues,
};

export const filterQuerypattern = /\{!tag=(.*?)\}(.*?):(.*?.*)/;
